<template>
    <div class="container details-container">
        <template v-if="subject==='xcb'">
                <xcb :activity="activity" :subject="subject" ></xcb>
        </template>
    </div>
</template>

<script>
import xcb from './xcb';
export default {
        data(){
            return {
                subject:'',
                activity:''
            }
        },
        components:{
            xcb
        },
        mounted(){
            this.subject=this.$route.params.subject;
            this.activity=this.$route.params.activity;
        }
    }
</script>

<style lang="sass" scoped>

</style>